import { useState, useEffect } from "react";
import { T } from "../../data/Tokens";

// ─── Nav groups config ────────────────────────────────────────────────────────
const NAV_GROUPS = [
  { group: "", items: [
    { id: "dashboard",  label: "Dashboard",      icon: <HomeIcon /> },
  ]},
  { group: "Store", items: [
    { id: "orders",     label: "Orders",         icon: <CartIcon />,   },
    { id: "products",   label: "Products",       icon: <PkgIcon />  },
   { id: "leads", label: "Leads", icon: <TagIcon /> },
    { id: "customers",  label: "Customers",      icon: <UsersIcon />,},
    // { id: "reviews",    label: "Reviews",        icon: <StarIcon /> },
    { id: "coupons",    label: "Coupons",        icon: <TicketIcon /> },
    { id: "inventory",  label: "Inventory",      icon: <LayersIcon /> },

  ]},
  { group: "Catalog", items: [
    { id: "photobooks", label: "Photo Books",    icon: <BookIcon />  },
    { id: "photobook-orders", label: "Photobook Orders", icon: <PkgIcon />  }, 
     { id: "HomeCircle",        label: "Home Circle",            icon: <MonIcon />    },
    { id: "HomeDaily",  label: "Home Daily",      icon: <BookIcon />  },
    { id: "HomeSlider",  label: "Home Slider",       icon: <BookIcon />  },
    { id: "HomeNotebook",  label: "Home Notebook",       icon: <BookIcon />  },
    { id: "HomePromotional",  label: "Home Promotional",       icon: <BookIcon />  },
    { id: "HomeClient",  label: "Home Client",       icon: <BookIcon />  },
    { id: "HomeVideo", label: "Home Reels", icon: <VideoIcon /> },

    // { id: "diaries",    label: "Diaries",        icon: <PenIcon />   },
    // { id: "corporate",  label: "Corporate",      icon: <BldgIcon />  },
    // { id: "gifts",      label: "Gift Hampers",   icon: <GiftIcon />  },
    // { id: "custom",     label: "Custom Orders",  icon: <StarIcon />  },
  ]},
  { group: "Finance", items: [
    { id: "analytics",  label: "Analytics",      icon: <BarIcon />   },
    // { id: "payments",   label: "Payments",       icon: <CardIcon />  },
    // { id: "shipping",   label: "Shipping",       icon: <TruckIcon /> },
    // { id: "returns",    label: "Returns",        icon: <ReturnIcon />},
  ]},
  { group: "Content", items: [
    { id: "blogs",      label: "Blogs",          icon: <PenIcon />   },
    // { id: "media",      label: "Media Library",  icon: <ImgIcon />   },
   
   
    { id: "newsletter", label: "Newsletter",     icon: <MailIcon />  },
      { id: "contact",    label: "Inquiries",      icon: <MsgIcon />   },
  ]},
  { group: "Admin", items: [
    // { id: "users",      label: "Users & Roles",  icon: <UserCogIcon />},
    { id: "settings",   label: "Settings",       icon: <GearIcon />  },
  ]},
];

// ─── Inline Icons ─────────────────────────────────────────────────────────────
function HomeIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>; }
function CartIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>; }
function PkgIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>; }
function TagIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>; }
function UsersIcon()   { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>; }
function StarIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>; }
function TicketIcon()  { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z"/></svg>; }
function LayersIcon()  { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>; }
function BookIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>; }
function PenIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>; }
function BldgIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><rect x="3" y="3" width="18" height="18" rx="1"/><path d="M9 3v18M3 9h6M3 15h6M15 7h2M15 11h2M15 15h2"/></svg>; }
function GiftIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>; }
function BarIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>; }
function CardIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>; }
function TruckIcon()   { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>; }
function ReturnIcon()  { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.76"/></svg>; }
function ImgIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>; }
function MonIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>; }
function MailIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>; }
function VideoIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="w-4 h-4">
      <rect x="2" y="6" width="14" height="12" rx="2" />
      <path d="M16 10.5 21 7.5v9l-5-3v-3Z" strokeLinejoin="round" />
    </svg>
  );
}
function MsgIcon()     { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>; }
function UserCogIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 0 1 4-4h4"/><circle cx="19" cy="19" r="3"/></svg>; }
function GearIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>; }
function MenuIcon()    { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-5 h-5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>; }
function LogoutIcon()  { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-4 h-4"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>; }

// ─── Floral decoration ────────────────────────────────────────────────────────
function FloralDecor() {
  return (
    <div className="px-4 pb-2 flex justify-center pointer-events-none select-none">
      <svg viewBox="0 0 100 70" className="w-24 opacity-40">
        <line x1="50" y1="70" x2="50" y2="35" stroke={T.gold} strokeWidth="1.2"/>
        {[[50,35],[30,38],[70,36],[18,28],[82,26]].map(([cx,cy],i) => (
          <g key={i}>
            {[0,60,120,180,240,300].map(a => {
              const r = i === 0 ? 9 : 7;
              const px = cx + r * Math.cos(a * Math.PI / 180);
              const py = cy + r * Math.sin(a * Math.PI / 180);
              return <circle key={a} cx={px} cy={py} r={i === 0 ? 3 : 2.5} fill={T.champagne} opacity="0.8"/>;
            })}
            <circle cx={cx} cy={cy} r={i === 0 ? 3.5 : 3} fill={T.gold} opacity="0.7"/>
          </g>
        ))}
        <line x1="50" y1="60" x2="30" y2="42" stroke={T.gold} strokeWidth="0.8"/>
        <line x1="50" y1="55" x2="70" y2="40" stroke={T.gold} strokeWidth="0.8"/>
        <line x1="50" y1="50" x2="18" y2="32" stroke={T.gold} strokeWidth="0.6"/>
        <line x1="50" y1="48" x2="82" y2="30" stroke={T.gold} strokeWidth="0.6"/>
      </svg>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// SIDEBAR COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════
export default function AdminSidebar({ active, setActive, collapsed, setCollapsed, onLogout }) {
  // ── Mobile drawer state (does not affect desktop behaviour at all) ─────────
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  // Auto-close the drawer if the viewport grows back into desktop size
  useEffect(() => { if (!isMobile) setMobileOpen(false); }, [isMobile]);

  // ── NEW: agar user kisi link ko naye tab mein khole (ya app se dur switch kare),
  // to is tab ka mobile drawer automatically band ho jaye — Page Visibility API se. ──
  useEffect(() => {
    const closeOnHide = () => { if (document.hidden) setMobileOpen(false); };
    document.addEventListener("visibilitychange", closeOnHide);
    window.addEventListener("blur", closeOnHide);
    return () => {
      document.removeEventListener("visibilitychange", closeOnHide);
      window.removeEventListener("blur", closeOnHide);
    };
  }, []);

  // On mobile the sidebar is always a full drawer — desktop "collapsed" mode
  // (icon-only rail) doesn't apply there, so labels always show in the drawer.
  const showLabels = isMobile ? true : !collapsed;
  const sidebarWidth = isMobile ? 248 : (collapsed ? 68 : 228);

  // ── NEW: solid fallback color — agar T.sidebar kisi wajah se undefined/transparent
  // resolve ho (e.g. token missing), tab bhi drawer aur trigger button transparent
  // nahi dikhenge, hamesha ek solid background milega. ──
  const solidSidebarBg = T.sidebar || "#FFFFFF";

  const handleMenuToggle = () => {
    if (isMobile) setMobileOpen(false);
    else setCollapsed(o => !o);
  };

  const handleItemClick = (id) => {
    setActive(id);
    if (isMobile) setMobileOpen(false);
  };

  return (
    <>
      {/* ── Mobile hamburger trigger (hidden once drawer is open) ── */}
      {isMobile && !mobileOpen && (
        <button onClick={() => setMobileOpen(true)}
          className="md:hidden fixed top-4 left-4 p-2.5 rounded-xl"
          style={{ backgroundColor: solidSidebarBg, opacity: 1, border: `1px solid ${T.border}`, color: T.textPri, zIndex: 60, boxShadow: "0 4px 14px rgba(0,0,0,0.12)" }}>
          <MenuIcon />
        </button>
      )}

      {/* ── Mobile backdrop ── */}
      {isMobile && mobileOpen && (
        <div className="md:hidden fixed inset-0"
          style={{ background: "rgba(0,0,0,0.42)", zIndex: 49 }}
          onClick={() => setMobileOpen(false)} />
      )}

      <aside
        className="flex-shrink-0 flex flex-col transition-all duration-300"
        style={{
          backgroundColor: solidSidebarBg,
          opacity: 1,
          borderRight: `1px solid ${T.border}`,
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          overflow: "hidden",
          zIndex: 50,
          width: sidebarWidth,
          transform: isMobile ? (mobileOpen ? "translateX(0)" : "translateX(-100%)") : "translateX(0)",
        }}>

        {/* ── Logo ── */}
        <div className="flex items-center gap-3 px-4 py-5 ml-4" style={{ borderBottom: `1px solid ${T.border}` }}>

          {showLabels && (
            <div>
              <p className="text-[32px] font-normal leading-tight" style={{ color: T.textPri, fontFamily: "'Dancing Script', cursive" }}>
                Aishcraft
              </p>
              <p className="text-[8px] tracking-[0.15em] uppercase" style={{ color: T.textSec }}>
                Crafting Your Stories
              </p>
            </div>
          )}
          <button onClick={handleMenuToggle}
            className="ml-auto p-1 rounded-lg transition-colors hover:bg-amber-50 flex-shrink-0"
            style={{ color: T.textSec }}>
            <MenuIcon />
          </button>
        </div>

        {/* ── Nav ── */}
    <nav
  data-lenis-prevent
  className="flex-1 px-2 py-3"
  style={{
    overflowY: "auto",
    scrollbarWidth: "none",
  }}
>
          {NAV_GROUPS.map(group => (
            <div key={group.group} className="mb-3">
              {showLabels && group.group && (
                <p className="text-[9px] font-bold uppercase tracking-[0.15em] px-3 mb-1" style={{ color: T.textSec }}>
                  {group.group}
                </p>
              )}
              <div className="space-y-0.5">
                {group.items.map(item => {
                  const isA = active === item.id;
                  return (
                    <button key={item.id} onClick={() => handleItemClick(item.id)}
                      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-150"
                      style={isA
                        ? { background: T.goldL, color: T.goldD, fontWeight: 600 }
                        : { color: T.textSec }}>
                      <span style={{ color: isA ? T.gold : T.textSec, flexShrink: 0 }}>
                        {item.icon}
                      </span>
                      {showLabels && <span className="text-[13px] flex-1">{item.label}</span>}
                      {showLabels && item.badge && (
                        <span className="text-[10px] font-bold text-white px-1.5 py-0.5 rounded-full min-w-[18px] text-center"
                          style={{ background: T.gold }}>
                          {item.badge}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>

        {/* ── Floral ── */}
        {showLabels && <FloralDecor />}

        {/* ── Logout ── */}
        <div className="px-2 pb-3" style={{ borderTop: `1px solid ${T.border}`, paddingTop: 8 }}>
          <button
            onClick={onLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all hover:bg-red-50"
          >
            <span style={{ flexShrink: 0 }}><LogoutIcon /></span>
            {showLabels && <span className="text-[13px]">Logout</span>}
          </button>
        </div>
      </aside>
    </>
  );
}